import { render, staticRenderFns } from "./ContactNotesTable.vue?vue&type=template&id=a674eeda&"
import script from "./ContactNotesTable.vue?vue&type=script&lang=js&"
export * from "./ContactNotesTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports